export default "__VITE_ASSET__0552cc9d__"